module.exports = __webpack_public_path__ + "media/apps/main/containers/portfolio/Export/Docx/assets/Bold/sdgIcons/sdg9-43b67d32afc0f39fbff1a1f3cc4b2772.png";